module.exports = __webpack_public_path__ + "img/iq.iq7a8858e.svg";